import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SubMenuList from './pages/SubMenuList';

export default function SubMenuListFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <SubMenuList />
        </Route>
      </Switch>
    </div>
  );
}
